module.exports = __webpack_public_path__ + "img/aoteli.f6b1c677.svg";